export const translations = {
  pt: {
    nav: {
      story: "Nossa História",
      properties: "Alojamentos",
      location: "Localização",
      region: "A Região",
      gallery: "Galeria",
      contact: "Reservar",
    },
    hero: {
      location: "Vila Chã · Vila do Conde · Portugal",
      title_1: "Villa d'",
      title_2: "Avó Dalva",
      tagline: "Um refúgio à beira-mar onde o tempo abranda e os dias parecem não ter fim.",
      cta_primary: "Ver Alojamentos",
      cta_secondary: "Fazer Reserva",
      scroll: "Descobrir",
      badge: "V3 + V1 · Boutique",
    },
    story: {
      eyebrow: "A Nossa História",
      title_1: "Um recanto no campo ",
      title_italic: "com vista para o mar",
      title_2: "",
      p1: "A avó Dalva sempre recebia toda a gente de braços abertos e sorriso nos lábios. Foi esse espírito que nos inspirou a criar este lugar.",
      p2: "Aqui o tempo abranda, na simplicidade da natureza, onde o campo abraça o mar. Aqui pode esperar conforto descomprometido e tranquilidade com cheiro a maresia.",
      p3: "Dois alojamentos independentes, pensados ao pormenor para proporcionar o maior conforto, longe do barulho e da rotina.",
      stat_1_label: "Minuto a pé da praia",
      stat_2_label: "Hóspedes (até)",
      stat_3_label: "Alojamentos boutique",
    },
    properties: {
      eyebrow: "Os Nossos Espaços",
      title_1: "Dois alojamentos, ",
      title_italic: "uma experiência única",
      subtitle: "Os espaços estão preparados para oferecer o maior conforto e funcionalidade, num ambiente descontraído e requintado.",
      v3_name: "Villa V3",
      v3_tag: "A casa de família",
      v3_desc: "Uma casa acolhedora, ideal para famílias. Dispõe de ar condicionado, 3 quartos, um dos quais suite, uma sala espaçosa, sofá-cama, cozinha toda equipada e casa de banho. TV e WiFi.",
      v3_features: ["3 Quartos", "2 Casas de Banho", "Cozinha equipada", "Ar condicionado", "Sala de Estar / Jantar", "Wi-Fi & TV", "Sofá-cama", "Até 8 pessoas"],
      v1_name: "V1",
      v1_tag: "O refúgio íntimo",
      v1_desc: "Ideal para casal com uma criança. Kitchenette equipada, 1 quarto e casa de banho. Ar condicionado, WiFi e TV.",
      v1_features: ["1 Quarto", "Casa de banho", "Kitchenette", "Ar condicionado", "Wi-Fi & TV", "Até 3 pessoas"],
      per_night: "por noite",
      reserve: "Reservar",
      shared_eyebrow: "Espaço Exterior Partilhado",
      shared_title_1: "Um jardim ",
      shared_title_italic: "à beira-mar",
      shared_p1: "As duas casas partilham um generoso e amplo espaço exterior, ideal para quem valoriza a liberdade e o contacto com a natureza. Equipado com mobiliário exterior funcional e de qualidade.",
      shared_p2: "Uma zona de lazer pensada para refeições ao ar livre — cenário perfeito para o encontro de família ou amigos, rodeados pelo verde do jardim e o azul do mar no horizonte.",
    },
    amenities: {
      eyebrow: "O que incluímos",
      title_1: "Tudo o que precisa para ",
      title_italic: "descansar",
      items: [
        { t: "A 1 min a pé da praia" },
        { t: "Wi-Fi de alta velocidade" },
        { t: "Vista e acesso ao mar" },
        { t: "Espaço exterior com jardim, mobiliário e churrasqueira" },
        { t: "Roupa de cama e toalhas" },
        { t: "Cozinha totalmente equipada" },
        { t: "Ar condicionado" },
        { t: "Não são permitidos animais" },
      ],
    },
    ribbon: ["1 min da praia", "Vista mar", "Cozinha equipada", "Ar condicionado", "WiFi alta velocidade", "20 min do Porto"],
    location: {
      eyebrow: "Onde Estamos",
      title_1: "Vila Chã, ",
      title_italic: "Vila do Conde",
      subtitle: "Vila Chã é daqueles sítios que os portugueses guardam como segredo. Uma aldeia costeira autêntica e pitoresca, com praia tranquila, ar puro e gente simpática, a 20 minutos do Porto.",
      items: [
        { label: "Praia de Vila Chã", value: "1 minuto a pé · praia tranquila de areia fina" },
        { label: "Centro de Vila do Conde", value: "15 minutos de carro · história, gastronomia e comércio" },
        { label: "Aeroporto Francisco Sá Carneiro", value: "20 minutos de carro · Porto" },
        { label: "Vila do Conde Porto Fashion Outlet", value: "8 minutos de carro · marcas de moda e centro comercial" },
        { label: "Azurara Surf School", value: "15 minutos de carro · escola de surf em Vila do Conde" },
      ],
      address: "R. da Praia 421, 4485-691 Vila Chã, Vila do Conde",
    },
    region: {
      eyebrow: "À sua porta",
      title_1: "Explorar ",
      title_italic: "a região",
      subtitle: "Vila Chã tem tudo o que precisa a poucos passos. Eis as nossas sugestões para aproveitar ao máximo a estadia.",
      restaurants_title: "Restaurantes por perto",
      poi_title: "Pontos de Interesse",
      activities_title: "O que Fazer",
      restaurants: [
        { name: "Salitre", url: "https://share.google/fPnnP0v5ayerAfkqa" },
        { name: "Taskuinha", url: "https://share.google/Srh2gza5ZV1a6Kha8" },
        { name: "Caravela", url: "https://share.google/JKXZvvRW0A1bhcpZ5" },
        { name: "Estaleiro", url: "https://share.google/f1Pc5C3KUMZJ9UI66" },
      ],
      poi: [
        { name: "Paisagem Protegida de Vila Chã", desc: "Cordões dunares, rochedos e zonas húmidas de grande qualidade paisagística, mesmo à porta de casa." },
        { name: "Praia dos Barcos", desc: "Uma praia com história, onde os pescadores guardam as suas embarcações. Areia fina e ambiente autêntico.", image: "/images/praia-barcos.jpg" },
      ],
      activities: [
        { name: "Praia de Vila Chã", desc: "A 1 minuto a pé. Praia tranquila de areia fina, ideal para banhos, mergulho e pesca lúdica.", image: "/images/praia-vila-cha.jpg" },
        { name: "Caminho Português da Costa", desc: "O famoso percurso de Santiago de Compostela passa mesmo por Vila Chã. Uma caminhada inesquecível.", image: "/images/caminho-costa.jpg" },
      ],
    },
    gallery: {
      eyebrow: "Galeria",
      title_1: "A villa em ",
      title_italic: "imagens",
    },
    video: {
      eyebrow: "Um olhar sobre a Villa",
      title_1: "Conheça a ",
      title_italic: "Villa d'Avó Dalva",
      subtitle: "Um passeio pelos espaços, o jardim e a proximidade ao mar. Cada detalhe pensado para que se sinta em casa.",
      caption: "Um refúgio à beira-mar",
      hint: "Carregue em play para iniciar o vídeo",
    },
    booking: {
      eyebrow: "Reservas & Contacto",
      title_1: "Reserve a sua ",
      title_italic: "estadia",
      subtitle: "Para reservas ou esclarecimentos adicionais, contacte-nos diretamente.",
      whatsapp_label: "WhatsApp & Telefone",
      email_label: "Email",
      location_label: "Localização",
      hours_label: "Horários",
      hours_value: "Check-in: a partir das 15h00\nCheck-out: até às 11h00",
      payment_label: "Pagamento",
      payment_value: "Transferência bancária · MBWay",
      cancel_label: "Cancelamento",
      cancel_value: "Política flexível. Consulte-nos para detalhes.",
      form_title: "Pedido de Reserva",
      form_subtitle: "Preencha o formulário e entraremos em contacto para confirmar disponibilidade.",
      first_name: "Nome",
      last_name: "Apelido",
      email: "Email",
      phone: "Telefone / WhatsApp",
      accommodation: "Alojamento pretendido",
      select_option: "Selecione uma opção",
      v3_option: "Villa V3 · até 8 pessoas",
      v1_option: "V1 · até 3 pessoas",
      both_option: "Ambos os alojamentos",
      arrival: "Data de chegada",
      departure: "Data de partida",
      adults: "Nº de adultos",
      children: "Nº de crianças",
      message: "Mensagem / Pedidos especiais",
      consent: "Concordo com o tratamento dos meus dados para resposta a este pedido, conforme a política de privacidade.",
      submit: "Enviar Pedido de Reserva",
      sending: "A enviar...",
      or_wa: "Prefere resposta mais rápida? Fale connosco pelo WhatsApp.",
      wa_btn: "WhatsApp",
      success_title: "Pedido enviado com sucesso!",
      success_sub: "Obrigado pelo seu interesse. Entraremos em contacto em menos de 24 horas. Até breve · Vila Chã espera por si.",
      required: "Campos obrigatórios",
    },
    footer: {
      tagline_1: "Onde a tranquilidade encontra o conforto,",
      tagline_2: "e cada momento se transforma numa memória.",
      bottom: "Vila Chã espera por si · Est. 2026",
      cta: "Reservar a minha estadia",
      privacy: "Política de Privacidade",
      guest: "Informações Úteis",
      rights: "Todos os direitos reservados",
    },
  },
  en: {
    nav: {
      story: "Our Story",
      properties: "Accommodations",
      location: "Location",
      region: "The Region",
      gallery: "Gallery",
      contact: "Book",
    },
    hero: {
      location: "Vila Chã · Vila do Conde · Portugal",
      title_1: "Villa d'",
      title_2: "Avó Dalva",
      tagline: "A refuge by the sea — where time slows down, and the days seem never to end.",
      cta_primary: "Discover the Stays",
      cta_secondary: "Book Now",
      scroll: "Scroll",
      badge: "V3 + V1 · Boutique",
    },
    story: {
      eyebrow: "Our Story",
      title_1: "A countryside hideaway ",
      title_italic: "facing the sea",
      title_2: "",
      p1: "Grandma Dalva always welcomed everyone with open arms and a smile on her lips. It is that very spirit that inspired this place.",
      p2: "Here, time slows down — in the simplicity of nature, where the countryside meets the sea. You can expect quiet comfort, an unhurried ease, and stillness carrying the scent of the salt sea.",
      p3: "Two independent stays, considered down to the smallest detail to offer the deepest sense of comfort — far from the noise, far from the routine.",
      stat_1_label: "Minute on foot to the beach",
      stat_2_label: "Guests, up to",
      stat_3_label: "Boutique stays",
    },
    properties: {
      eyebrow: "Our Spaces",
      title_1: "Two havens, ",
      title_italic: "one singular experience",
      subtitle: "Each space is prepared to offer the deepest comfort and functionality — in an atmosphere that feels relaxed, yet quietly refined.",
      v3_name: "Villa V3",
      v3_tag: "The family house",
      v3_desc: "A welcoming home, ideal for families. Air conditioning, 3 bedrooms (one of them an ensuite), a generous living room, sofa-bed, fully-equipped kitchen and bathroom. TV and Wi-Fi included.",
      v3_features: ["3 Bedrooms", "2 Bathrooms", "Fully-equipped kitchen", "Air conditioning", "Living / Dining room", "Wi-Fi & TV", "Sofa-bed", "Sleeps up to 8"],
      v1_name: "V1",
      v1_tag: "The intimate retreat",
      v1_desc: "Perfect for a couple with a child. Equipped kitchenette, 1 bedroom and bathroom. Air conditioning, Wi-Fi and TV.",
      v1_features: ["1 Bedroom", "Bathroom", "Kitchenette", "Air conditioning", "Wi-Fi & TV", "Sleeps up to 3"],
      per_night: "per night",
      reserve: "Book",
      shared_eyebrow: "Shared outdoor space",
      shared_title_1: "A garden ",
      shared_title_italic: "by the sea",
      shared_p1: "The two houses share a generous open-air space — ideal for those who value freedom and a closeness to nature. Furnished with quality outdoor pieces, made for slow afternoons.",
      shared_p2: "A leisure area thought through for meals al fresco — the perfect setting for gatherings of family and friends, surrounded by the green of the garden and the blue of the sea on the horizon.",
    },
    amenities: {
      eyebrow: "What's included",
      title_1: "Everything you need to ",
      title_italic: "slow down",
      items: [
        { t: "One minute on foot to the beach" },
        { t: "High-speed Wi-Fi" },
        { t: "Sea view & easy access" },
        { t: "Outdoor garden with furniture and BBQ" },
        { t: "Linen and bath towels" },
        { t: "Fully-equipped kitchen" },
        { t: "Air conditioning" },
        { t: "Pets are not permitted" },
      ],
    },
    ribbon: ["1 min from the sea", "Ocean views", "Equipped kitchen", "Air conditioning", "High-speed Wi-Fi", "20 min from Porto"],
    location: {
      eyebrow: "Where we are",
      title_1: "Vila Chã, ",
      title_italic: "Vila do Conde",
      subtitle: "Vila Chã is one of those places the Portuguese keep quietly to themselves — an authentic, picturesque coastal village of fine-sand beaches, pure sea air and warm, welcoming people, just twenty minutes from Porto.",
      items: [
        { label: "Vila Chã Beach", value: "1 minute on foot · a calm beach of fine sand" },
        { label: "Centre of Vila do Conde", value: "15 minutes by car · history, gastronomy & boutiques" },
        { label: "Francisco Sá Carneiro Airport", value: "20 minutes by car · Porto" },
        { label: "Vila do Conde Porto Fashion Outlet", value: "8 minutes by car · designer brands & shopping centre" },
        { label: "Azurara Surf School", value: "15 minutes by car · surf school in Vila do Conde" },
      ],
      address: "R. da Praia 421, 4485-691 Vila Chã, Vila do Conde",
    },
    region: {
      eyebrow: "Right at your door",
      title_1: "Explore ",
      title_italic: "the region",
      subtitle: "Vila Chã has everything you might wish for, all within a few steps. A short list of our own favourites — to make the most of your time here.",
      restaurants_title: "Restaurants nearby",
      poi_title: "Points of Interest",
      activities_title: "Things to Do",
      restaurants: [
        { name: "Salitre", url: "https://share.google/fPnnP0v5ayerAfkqa" },
        { name: "Taskuinha", url: "https://share.google/Srh2gza5ZV1a6Kha8" },
        { name: "Caravela", url: "https://share.google/JKXZvvRW0A1bhcpZ5" },
        { name: "Estaleiro", url: "https://share.google/f1Pc5C3KUMZJ9UI66" },
      ],
      poi: [
        { name: "Vila Chã Protected Landscape", desc: "Sweeping dunes, rocky outcrops and tidal wetlands of remarkable beauty — all just steps from the door." },
        { name: "Praia dos Barcos", desc: "A beach steeped in history, where the local fishermen still keep their boats. Fine sand, raw atmosphere — and one of the most photogenic shores on this stretch of coast.", image: "/images/praia-barcos.jpg" },
      ],
      activities: [
        { name: "Vila Chã Beach", desc: "Just one minute on foot. A serene beach of fine sand, ideal for bathing, snorkelling and a slow afternoon by the water — far from the crowds.", image: "/images/praia-vila-cha.jpg" },
        { name: "Portuguese Coastal Way", desc: "The legendary pilgrim route to Santiago de Compostela passes right through Vila Chã — an unforgettable walk along the wild Atlantic coast.", image: "/images/caminho-costa.jpg" },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title_1: "The villa, ",
      title_italic: "in photographs",
    },
    video: {
      eyebrow: "A look inside",
      title_1: "Step inside ",
      title_italic: "Villa d'Avó Dalva",
      subtitle: "A short tour through the rooms, the garden and the closeness of the sea — every detail considered, so you feel at home from the first moment.",
      caption: "A refuge by the sea",
      hint: "Press play to begin",
    },
    booking: {
      eyebrow: "Bookings & Enquiries",
      title_1: "Book your ",
      title_italic: "stay",
      subtitle: "For bookings or any further information, please get in touch with us directly.",
      whatsapp_label: "WhatsApp & Phone",
      email_label: "Email",
      location_label: "Address",
      hours_label: "Hours",
      hours_value: "Check-in · from 3:00 PM\nCheck-out · by 11:00 AM",
      payment_label: "Payment",
      payment_value: "Bank transfer · MB Way",
      cancel_label: "Cancellation",
      cancel_value: "A flexible policy. Get in touch for the details that apply to your stay.",
      form_title: "Booking Enquiry",
      form_subtitle: "Send us your details and we'll be in touch shortly to confirm availability.",
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      phone: "Phone / WhatsApp",
      accommodation: "Which stay",
      select_option: "Please choose one",
      v3_option: "Villa V3 · sleeps up to 8",
      v1_option: "V1 · sleeps up to 3",
      both_option: "Both stays together",
      arrival: "Arrival",
      departure: "Departure",
      adults: "Adults",
      children: "Children",
      message: "Message / special requests",
      consent: "I consent to the processing of my personal data for the purpose of replying to this enquiry, in accordance with the privacy policy of Villa d'Avó Dalva.",
      submit: "Send Enquiry",
      sending: "Sending…",
      or_wa: "Hoping for a quicker reply? Send us a message on WhatsApp.",
      wa_btn: "WhatsApp",
      success_title: "Your enquiry has been sent.",
      success_sub: "Thank you for your interest in Villa d'Avó Dalva. We'll be in touch within 24 hours to confirm availability. See you soon — Vila Chã is waiting.",
      required: "Please complete the required fields",
    },
    footer: {
      tagline_1: "Where stillness meets comfort,",
      tagline_2: "and every moment quietly becomes a memory.",
      bottom: "Vila Chã is waiting · Est. 2026",
      cta: "Book my stay",
      privacy: "Privacy Policy",
      guest: "Guest Information",
      rights: "All rights reserved",
    },
  },
};
;
;
